import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrButton from '@components/BrButton';
import BrIcons from '@components/BrIcons';
import BrInputBox from '@components/BrInputBox';
import ColorStyles from '@components/ColorStyles';
import './brSearchBox.scss';

export default class BrSearchBox extends PureComponent {
  static propTypes = {
    query: PropTypes.string,
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    isAjaxSearch: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onQueryChange: PropTypes.func.isRequired,
    onQuerySubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    placeholder: 'Search...',
    autoFocus: true,
    isDisabled: false,
    isAjaxSearch: false,
  };

  ajaxSearchSubmit = () => this.props.onQuerySubmit(this.props.query);

  render() {
    const {
      query,
      className,
      autoFocus,
      placeholder,
      isAjaxSearch,
      isDisabled,
      onQueryChange,
      onQuerySubmit,
    } = this.props;

    const searchBoxClass = cn('br-search-box', className, {
      disabled: isDisabled,
    });

    let autoFocusSearchInputBox = autoFocus;
    let searchInputClassName = 'br-search-query-input-box';
    if (isDisabled) {
      autoFocusSearchInputBox = false;
      searchInputClassName += ' disabled';
    }

    return (
      <div className={searchBoxClass}>
        <BrInputBox
          className={searchInputClassName}
          placeholder={placeholder}
          value={query}
          icon={!isAjaxSearch ? <BrIcons.Search isSubComp /> : null}
          clearable={!!query}
          onInput={onQueryChange}
          onEnter={onQuerySubmit}
          autoFocus={autoFocusSearchInputBox}
        />
        {isAjaxSearch && (
          <BrButton
            isDisabled={isDisabled}
            icon={<BrIcons.Search isSubComp colorStyle={ColorStyles.WHITE} />}
            title=""
            colorStyle={ColorStyles.BGBLUE}
            onClick={this.ajaxSearchSubmit}
          />
        )}
      </div>
    );
  }
}
